import Vue from "vue";
import Router from "vue-router";
import TournamentPage from "@/screens/tournament";
import MainPage from "@/screens/main_page";
import HistoryPage from "@/screens/history";
import GamePage from "@/screens/game";
import WalletPage from "@/screens/wallet";
import AccountPage from "@/screens/account";
import OffersPage from "@/screens/offers";
import RewardsPage from "@/screens/rewards";
import TransactionPage from "@/screens/transactions";
import RedeemPage from "@/screens/redeem";
import ReferralsPage from "@/screens/referrals";
import GiftCardPage from "@/screens/gift-cards";
import OfferDetailsPage from "@/screens/offer-detail";
import GiftCardDetailsPage from "@/screens/gift-card-detail";
import GameZonePage from "@/screens/game-zone";
import QuizZonePage from "@/screens/quiz-zone";
import QuizDetailsCustomPage from "@/screens/quiz-details-custom";
import QuizQuestionsPage from "@/screens/quiz-questions";
import CongratsPage from "@/screens/congrats";
import LeadboardPage from "@/screens/leadboard";
import QuizHistoryPage from "@/screens/quiz-history";
import StampCampaignPage from "@/screens/stamp-campaign";
import LeaderboardDetail from "@/screens/Leaderboard/leaderboardDetail";
import Leaderboard from "@/screens/Leaderboard/leaderboard";
import LeaderboardScoreHistory from "@/screens/Leaderboard/leaderScoreHistory";
import Advance_Checkin from "@/screens/advance_checkin/adv_checkin";
import ReffleDetail from "@/screens/Raffle/raffleDetail";
import RaffleHistory from "@/screens/Raffle/raffleHistory";
import ConcertDetailPage from "@/screens/Raffle/concertDetail";
import VueSocialSharing from "vue-social-sharing";
import InfiniteLoading from "vue-infinite-loading";
import PollPage from "@/screens/poll";
import PollZonePage from "@/screens/poll-zone";
import SurveyZone from "../screens/survey-zone.vue";
import TriviaZone from "../screens/trivia-zone.vue";
import PollDetailsCustom from "../screens/poll-details-custom.vue";
import SurveyDetailsCustom from "../screens/survey-details-custom.vue";
import TriviaDetailsCustom from "../screens/trivia-details-custom.vue";
import NewQuizDetailsCustom from "../screens/newQuiz-details-custom.vue";
import SeeInvites from "../screens/seeInvites.vue";
import NewInvite from "../screens/new-invite.vue";
import LeaderboardContextHistory from "../screens/Leaderboard/LeaderboardContextHistory.vue";
import LeaderboardRankings from "../screens/Leaderboard/leaderboardRankings.vue";

Vue.use(Router);
Vue.use(InfiniteLoading);
Vue.use(VueSocialSharing);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/main_page",
      name: "main_page",
      component: MainPage
    },
    {
      path: "/",
      name: "offers",
      component: OffersPage
    },
    {
      path: "/history",
      name: "history",
      component: HistoryPage
    },
    {
      path: "/wallet",
      name: "wallet",
      component: WalletPage
    },
    {
      path: "/account",
      name: "account",
      component: AccountPage
    },
    {
      path: "/game",
      name: "game",
      component: GamePage
    },
    {
      path: "/offers/:id",
      name: "offer_details",
      component: OfferDetailsPage
    },
    {
      path: "/new-invites/:id",
      name: "newInvites",
      component: NewInvite
    },
    {
      path: "/rewards",
      name: "rewards",
      component: RewardsPage
    },
    {
      path: "/transactions",
      name: "transactions",
      component: TransactionPage
    },
    {
      path: "/redeem",
      name: "redeem",
      component: RedeemPage
    },
    {
      path: "/gift-cards",
      name: "gift_cards",
      component: GiftCardPage
    },
    {
      path: "/gift-cards/:id",
      name: "gift_card_details",
      component: GiftCardDetailsPage
    },
    {
      path: "/game-zone",
      name: "game_zone",
      component: GameZonePage
    },
    {
      path: "/tournament",
      name: "tournament",
      component: TournamentPage
    },
    {
      path: "/referrals",
      name: "referrals",
      component: ReferralsPage
    },
    {
      path: "/quiz-zone",
      name: "quiz_zone",
      component: QuizZonePage
    },
    {
      path: "/quiz-details-custom",
      name: "quiz_details_custom",
      component: QuizDetailsCustomPage
    },
    {
      path: "/new-quiz-details-custom",
      name: "new_quiz_details_custom",
      component: NewQuizDetailsCustom
    },
    {
      path: "/poll-details-custom",
      name: "poll_details_custom",
      component: PollDetailsCustom
    },
    {
      path: "/play-quiz",
      name: "quiz_questions",
      component: QuizQuestionsPage
    },
    {
      path: "/poll-zone",
      name: "poll_zone",
      component: PollZonePage
    },
    {
      path: "/survey-zone",
      name: "survey_zone",
      component: SurveyZone
    },
    {
      path: "/survey-details-custom",
      name: "survey_details_custom",
      component: SurveyDetailsCustom
    },
    {
      path: "/trivia-zone",
      name: "trivia_zone",
      component: TriviaZone
    },
    {
      path: "/trivia-details-custom",
      name: "trivia_details_custom",
      component: TriviaDetailsCustom
    },
    {
      path: "/see-all-invites",
      name: "seeInvites",
      component: SeeInvites
    },
    // {
    //   path: '/new-invites',
    //   name: 'newInvites',
    //   component: NewInvite
    // },
    {
      path: "/congrats",
      name: "congrats",
      component: CongratsPage
    },
    {
      path: "/leadboard",
      name: "leadboard",
      component: LeadboardPage
    },
    {
      path: "/quiz-history",
      name: "quiz_history",
      component: QuizHistoryPage
    },
    {
      path: "/stamp-campaign",
      name: "stamp_campaign",
      component: StampCampaignPage
    },
    {
      path: "/leaderboard-detail",
      name: "leaderboard_detail",
      component: LeaderboardDetail
    },
    {
      path: "/leaderboard-detail/:id",
      name: "leaderboard_detail_id",
      component: LeaderboardDetail
    },
    {
      path: "/leaderboard/:id",
      name: "leaderboard",
      component: Leaderboard
    },
    {
      path: "/leaderboardHistory/:id",
      name: "leaderboard_scoreHistory",
      component: LeaderboardScoreHistory
    },
    {
      path: "/leaderboardContextHistory/:id",
      name: "LeaderboardContextHistory",
      component: LeaderboardContextHistory
    },
    {
      path: "/leaderboardRankings/:id",
      name: "LeaderboardRankings",
      component: LeaderboardRankings
    },
    {
      path: "/raffleDetail/:id",
      name: "raffleDetail",
      component: ReffleDetail
    },
    {
      path: "/raffleHistory",
      name: "raffleDetail",
      component: RaffleHistory
    },
    {
      path: "/concertDetailPage/:id",
      name: "concertDetailPage",
      component: ConcertDetailPage
    },
    {
      path: "/advance_checkin",
      name: "advancecheckin",
      component: Advance_Checkin
    },
    {
      path: "/poll_page",
      name: "pollPage",
      component: PollPage
    },

    {
      path: "*",
      redirect: "/"
    }
  ]
});
